export default function Hero() {
  return (
    <section id="hero" className="hero">
      <div className="hero-content">
       
      </div>
    </section>
  )
}